// src/components/UserDetailsCard.jsx
import React, { useEffect, useState } from "react";
import { FaUser, FaEnvelope, FaIdBadge } from "react-icons/fa";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import Swal from "sweetalert2";
import "../styles/UserDetail.css";

const UserDetailsCard = ({ onClose }) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");

  const [userId, setUserId] = useState(null);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUsername(decoded.username);
        setEmail(decoded.email);
        setRole(decoded.role);
        setUserId(decoded.id);
      } catch (error) {
        console.error("Failed to decode token:", error);
      }
    }
  }, []);

  const canUpdatePassword = Boolean(
    currentPassword?.trim() &&
    newPassword?.trim() &&
    confirmPassword?.trim() &&
    newPassword === confirmPassword,
  );

  return (
    <div className="udc-wrapper">
      <div className="udc-card">
        <div className="udc-body">
          <h3 className="text-dark mb-3" style={{ fontWeight: 600 }}>
            User Detail
          </h3>
          <div className="udc-grid">
            <div className="udc-field">
              <label htmlFor="udc-username">
                <FaUser /> Username
              </label>
              <input id="udc-username" type="text" value={username} readOnly />
            </div>
            <div className="udc-field">
              <label htmlFor="udc-email">
                <FaEnvelope /> Email
              </label>
              <input id="udc-email" type="email" value={email} readOnly />
            </div>
            <div className="udc-field">
              <label htmlFor="udc-role">
                <FaIdBadge /> Role
              </label>
              <input id="udc-role" type="text" value={role} readOnly />
            </div>
          </div>

          <div className="udc-divider" />

          <h4 className="udc-section-title">Change Password</h4>
          <div className="udc-password-grid">
            <div className="udc-field">
              <label htmlFor="udc-current">Current password</label>
              <input
                id="udc-current"
                type="password"
                placeholder="Enter current password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </div>
            <div className="udc-field">
              <label htmlFor="udc-new">New password</label>
              <input
                id="udc-new"
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <div className="udc-field">
              <label htmlFor="udc-confirm">Confirm new password</label>
              <input
                id="udc-confirm"
                type="password"
                placeholder="Re-enter new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="udc-actions">
            <button
              type="button"
              className={
                canUpdatePassword && !saving
                  ? "btn btn-primary"
                  : "udc-btn-primary"
              }
              disabled={!canUpdatePassword || saving}
              onClick={async () => {
                if (!canUpdatePassword || saving) return;
                const id = userId;
                const url = `${API_URL}/api/user/${id}/password`;
                try {
                  setSaving(true);
                  const token = localStorage.getItem("authToken");
                  await axios.post(
                    url,
                    { currentPassword, newPassword },
                    {
                      headers: token
                        ? { Authorization: `Bearer ${token}` }
                        : {},
                    },
                  );
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Password updated successfully.",
                  });
                  setCurrentPassword("");
                  setNewPassword("");
                  setConfirmPassword("");
                } catch (err) {
                  const msg =
                    err?.response?.data?.error ||
                    err?.response?.data?.message ||
                    "Failed to update password.";
                  Swal.fire({ icon: "error", title: "Error", text: msg });
                } finally {
                  setSaving(false);
                }
              }}
            >
              {saving ? "Updating..." : "Update Password"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsCard;
